import React from "react";
import Header from "../features/home/components/Header";
import NavBar from "../features/dashboard/components/NavBar";
import { Outlet, useLocation } from "react-router-dom";

export type IHeaderLayoutProps = {
  screensWithoutHeader: string[];
};

const HeaderLayout: React.FC<IHeaderLayoutProps> = ({
  screensWithoutHeader,
}) => {
  const location = useLocation();
  console.log("location.pathname", location.pathname);
  return (
    <div>
      <div className="flex h-[100vh] min-h-full lg:flex-col-reverse xl:flex-row md:flex-col-reverse xs:flex-col-reverse sm:flex-col-reverse">
        <NavBar />
        <div
          className="overflow-y-scroll w-full md:h-[92vh] 
    lg:h-[99vh] xl:h-[99vh] max-sm-h-[99vh]
    max-xl:h-[99vh] max-lg:h-[99vh] sm:h-[92.6vh] max-sm:h-[92.6vh] no-scrollbar"
        >
          <div id="top-container" className="flex-1">
            <Header />
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export { HeaderLayout };
